import React from "react";
import { Container, Grid, Header, Image } from "semantic-ui-react";
import CategoryPage from "../Category/CategoryPage";
import PropTypes from "prop-types";

const LayoutPage = ({ categories, title }) => {
    return (
        <Container style={{ padding: "20px" }}>
            <Grid>
                <Grid.Column>
                    <Header as="h1" style={{ textAlign: "center" }}>
                        <Image src="/logo.jpg" size="large" href={"/"} verticalAlign={"top"}/>
                        {title}
                    </Header>
                    <CategoryPage categories={categories} />
                </Grid.Column>
            </Grid>
        </Container>
    );
};

LayoutPage.propTypes = {
    categories: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
};

export default LayoutPage;
